import React,{Component} from 'react';
import "./quizz.scss";
import {Grid, Card, CardContent, CardMedia,CardActions, Button, Radio, Switch, Slide} from  '@material-ui/core/';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import helpers from "../helpers/helpers";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';



class Quizz extends Component{
    constructor (props){
        super(props)
        this.state={
            questionEnCours: 0,
            answer: new Map(),
            questionComplete: false,
            slide: true,
            start:true
        }
        this.validateQuestion=this.validateQuestion.bind(this);
        this.changeQuestion=this.changeQuestion.bind(this);
    }
    isQuestionMultiple(){
        const question=this.props.content.questions[this.state.questionEnCours]
        let isMultiple=0
        question.items.forEach(item=>{
            if(item.value==="true")
            isMultiple++
        })
        return (isMultiple>1 ?true :false)
    }
    handleClick(indice, value){

        let mapCopy = this.state.answer;
        
        if(this.state.answer.has(indice)){
            mapCopy.delete(indice);
        }
        else {
            if(!this.isQuestionMultiple()){
                mapCopy=new Map();
            }
            mapCopy.set(indice, value);
        }
        this.setState({
            answer: mapCopy,
        }); 
    }

    changeQuestion(){
        const indice = this.state.questionEnCours+1;
        if(indice < this.props.content.questions.length){
            this.setState({
                questionEnCours: indice,
                questionComplete: false,
                answer: new Map(),
                slide: !this.state.slide,
                start:false
            });
        }else{
            this.props.handleNext();
        }
    }

   /*  validateQuestion(){
        let result;          
        let feedback = {
            value: "",
            content: ""
        }  
        result = "true"; 
        //if only one is false, the feedback will be false
        for (let v of this.state.answer) {
            if (v[1] === "false") { 
                result = "false"; 
            }
        }
        console.log(result);
        let feedback1 = this.props.content.questions[this.state.questionEnCours].feedbacks;
        feedback1.forEach(item => {
            if(item.value === result){
                feedback.content = item.label;
                feedback.value = result;
            }
        });
        console.log(feedback);
        this.setState({
            questionComplete: true,
            questionFeedback: feedback
        })
    } */
    validateQuestion(){
        let result;  
        result="true";       
        let feedback = {
            value: "",
            content: ""
        }  
            for (let v of this.state.answer) {
                //console.log(v)
                if (v[1] === "false") { 
                  
                    result = "false"; 
                }
            }
            if(result &&this.state.answer.length!==this.props.content.questions[this.state.questionEnCours].items.length){
                this.props.content.questions[this.state.questionEnCours].items.forEach((item,i)=>{
                    //console.log("item", item.action)
                    if(item.value==="true"){
                        if(!this.state.answer.has(i)){
                            result="false";
                        }   
    
                    }
                })
            }
            let feedback1 = this.props.content.questions[this.state.questionEnCours].feedbacks;
            console.log(feedback1)
            feedback1.forEach(item => {
               
                if(item.value === result){
                    console.log(Boolean(item.value), result,item)
                    feedback.content = item.label;
                    feedback.value = result;
                }
            });
        this.setState({
            questionComplete: true,
            questionFeedback: feedback
        })
    }
    getchecker(i){
        if(this.isQuestionMultiple())
         return <Switch value={i} color="primary" checked={this.state.answer.has(i)}/>  
         else
         return <Radio value={i} color="primary" checked={this.state.answer.has(i)}/>  
    }
    displayQuestions(question){
        if(!this.state.slide){
            setTimeout(function(){
                this.setState({
                    slide: true
                });
            }.bind(this), 200)
        }
        return (
            <Slide 
                direction={'left'}
                in={this.state.slide}
                mountOnEnter unmountOnExit>
                <CardContent className="quizz-viewer">
                    <p className={`question-bloc bg-${this.props.couleur}`}>{question.lib}</p>
                    <div className="bloc-items">
                        {question.items.map((item,i)=>{
                                return(
                                <div key={i} className="quizz-item" elevation={0} onClick={() => this.handleClick(i, item.value)}>
                                    {this.state.questionComplete&&this.displayIcons(i)}
                                    {this.getchecker(i)}
                                    <p>{item.label}</p>
                                </div>
                                )
                            })}
                    </div>
                </CardContent>  
            </Slide>
        )
    }
    
    displayFeedBack(){
        return(
            <div className={(this.state.questionFeedback.value === "true" ? "quizz-good" : "quizz-bad") + " quizz-feedback"}>
                <p dangerouslySetInnerHTML={helpers.cleanHTML(this.state.questionFeedback.content)}></p>
            </div>
        )
    }

    displayIcons(i){
        if(this.state.answer.has(i)){
            if(this.props.content.questions[this.state.questionEnCours].items[i].value==="true")
             return <CheckCircleOutlinedIcon className="green"/>
            else
            return <HighlightOffOutlinedIcon className="red"/>
        }else{
            if(this.props.content.questions[this.state.questionEnCours].items[i].value==="true")
            return <CheckCircleOutlinedIcon  className="green"/>
        }

    }
    
    render(){
        const content = this.props.content;
        const question = this.props.content.questions[this.state.questionEnCours];
        const img=this.props.image;
        return(
                 <Card elevation={0} className="content-wrapper">
                    <CardMedia
                        className="intro-img"
                        image={img}
                        title={content.title}
                    />
                    {this.state.questionComplete ? this.displayFeedBack() : null}
                    <Card className="content-quizz" variant={"outlined"}>
                        <div className="titre-quizz">
                            <h3>{content.title}</h3>
                            {this.state.start&&<p dangerouslySetInnerHTML={helpers.cleanHTML(content.incipit)} />}
                        </div>
                        {this.displayQuestions(question)}
                        <CardActions className="steps-bloc-btn">
                            <Button 
                            disabled={this.state.answer.size === 0 ? true : false}
                            onClick={this.state.questionComplete ? this.changeQuestion : this.validateQuestion} 
                            className={`button-quizz btn-bg-${this.props.couleur}`}>
                                {this.state.questionComplete ? 
                                <>
                                    {helpers.findLabelInData("BTN-CONTINUER")}
                                    <ArrowForwardIcon className="btn-quizz-arrow"/>
                                </>
                                : 
                                    helpers.findLabelInData("BTN-VALIDER")
                                }
                            </Button>
                        </CardActions>       
                    </Card>
                </Card>
        )
    }
}
export default Quizz;